<iframe *ngIf="arivisUrl && showArivisViewer && !isLocalhost" class="w-100 h-100 border-0" [src]="arivisUrl"></iframe>
<ca-apeer-alert *ngIf="isLocalhost" type="warning" class="w-100 h-100"
    >No iframes can be shown on localhost, because Chrome blocks them (CORS issue) and causes them to flicker.
</ca-apeer-alert>
<section *ngIf="showErrorMessage" class="h-100 error-message d-flex justify-content-center align-items-center">
    <div class="text-center">
        <ca-icon name="file-no" size="l" class="mb-3"></ca-icon>
        <br />
        {{ 'IMAGE_VIEWER.FILE_TYPE_NOT_SUPPORTED' | translate }}
        <br />
        {{ 'IMAGE_VIEWER.DOWNLOAD_FILE_INSTEAD' | translate }} <a target="_blank" [href]="imageUrl">here</a>.
    </div>
</section>
